import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Typography,
  Paper, 
  Box,
  Tab,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from '../common/components/LocalizationProvider';
import MainToolbar from '../main/MainToolbar';
import Container from '@mui/material/Container';
import TabContext from '@mui/lab/TabContext';
import ImageIcon from '@mui/icons-material/Image';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ActivitiesCircularGraph from './ActivitiesCircularGraph';
import ActivitiesBarGraph from './ActivitiesBarGraph';
import ActivitiesStyles from './ActivitiesStyles';
import { useTheme } from '@mui/styles';

import LoadingPage from '../LoadingPage';  // Adjust the path based on your directory structure

import {ReactComponent as Volante} from '../resources/images/track2you/Icons_Volante.svg';
import {ReactComponent as Hammers} from '../resources/images/track2you/Icons_Hammers.svg';
import {ReactComponent as Bed} from '../resources/images/track2you/Icons_Bed.svg';
import {ReactComponent as User} from '../resources/images/track2you/Icons_User.svg';
import {ReactComponent as ActivityMapIcon} from '../resources/images/track2you/Icons_Activity_Map.svg';
import {ReactComponent as InfoIcon} from '../resources/images/track2you/Icons_Hamburger_Menu.svg';

const ActivitiesPage = () => {
  const classes = ActivitiesStyles();
  const theme = useTheme();

  const [loading, setLoading] = useState(false);
  const totalWeekCounts = useSelector((state) => state.session.totalWeekCounts);
  const totalMonthCounts = useSelector((state) => state.session.totalMonthCounts);
  const totalYearCounts = useSelector((state) => state.session.totalYearCounts);
  const [dataRoundGraph, setRoundGraphData] = React.useState('0');
  const [valueRoundGraph, setRoundGraphValue] = React.useState('1');
  const [dataBarGraph, setBarGraphData] = React.useState('1');
  const [valueBarGraph, setBarGraphValue] = React.useState('1');
  const totalCounts = useSelector((state) => state.session.totalCounts);

  useEffect(() => {
    if(dataRoundGraph==0){
      setRoundGraphData(totalWeekCounts);
    }
    if (!totalWeekCounts || !totalMonthCounts || totalYearCounts || totalCounts || dataRoundGraph==0) {
      console.log("TotalCounts data not available yet. Fetching data...");
    } else {
      console.log("Total Week Counts:", totalWeekCounts);
      setLoading(false);
    }
  }, [totalWeekCounts, totalCounts, totalMonthCounts, totalYearCounts, dataRoundGraph]);

  const handleChange = (event, newValue) => {
    console.log("New value:", newValue);  // Check if this logs correctly
  
    // Set the state for the selected tab
    setRoundGraphValue(newValue);
  
    if(totalMonthCounts || totalWeekCounts || totalYearCounts){
      // Handle your data updates
      console.log("total month counts:", totalMonthCounts);
      switch (newValue) {
        case "1":
          setRoundGraphData(totalWeekCounts);
          break;
        case "2":
          setRoundGraphData(totalMonthCounts);
          break;
        case "3":
          setRoundGraphData(totalYearCounts);
          break;
        default:
          setRoundGraphData(totalWeekCounts);
          break;
      }
    }else{
      setRoundGraphData(0);
    }
    
  };
  

  const handleTimerChange = (event, timerValue) => {
    console.log("Bar graph:", timerValue);  // Check if this logs correctly
  
    // Set the state for the selected tab
    setBarGraphValue(timerValue);
  };

  const handleGraph = ActivitiesCircularGraph;
  const handleTimerGraph = ActivitiesBarGraph;

  if (loading) {
    return <LoadingPage message="Fetching your data..." />;
  }

  return (
    <div className={classes.root}>
      <Paper square elevation={3} className={classes.header}>
        <MainToolbar
          
        />
      </Paper>
      <Container className={classes.mainContainer}>
        <Typography className={classes.leftTitle} variant="h5" component="h5">
          Atividades <br /> Pessoais
        </Typography>

      <div className={classes.titleDiv}>
        <ActivityMapIcon className={classes.titleIcon} />
      </div>

      </Container>

      <TabContext value={valueRoundGraph}>
        <Box className={classes.activitiesTab}>
          <TabList 
            onChange={handleChange}  // Pass directly without extra arrow function
            aria-label="activities tab" 
            className={classes.activitiesTabButtons}
          >
            <Tab label="Semana" value="1" />
            <Tab label="Mês" value="2" />
            <Tab label="Ano" value="3" />
          </TabList>
        </Box>
        <TabPanel className={classes.activitiessTabPanel} value="1">
          {/* Content for "Semana" */}
        </TabPanel>
        <TabPanel className={classes.activitiessTabPanel} value="2">
          {/* Content for "Mês" */}
        </TabPanel>
        <TabPanel className={classes.activitiessTabPanel} value="3">
          {/* Content for "Ano" */}
        </TabPanel>
      </TabContext>


      {handleGraph(valueRoundGraph,dataRoundGraph)}

      <Container className={classes.timeContainer}>
        <Box>
          <Typography variant="h6" component="h6">
            Tempo de atividades
          </Typography>
          <Typography sx={{fontSize:'8pt'}}>
            Escolhe atividade que pretende visualizar
          </Typography>
        </Box>

        <div className={classes.titleDiv}>
          <InfoIcon className={classes.titleIcon} />
        </div>

      </Container>

      <TabContext value={valueBarGraph} >
        <Box className={classes.timerTab}>
          <TabList onChange={handleTimerChange} aria-label="activities tab" className={classes.timerTabButtons}>
            <Tab id="tab1" elevation={2} icon={<Volante />} value="1"  />
            <Tab id="tab2" icon={<Hammers/>}  value="2" />
            <Tab id="tab3" icon={<Bed />}  value="3" />
            <Tab id="tab4" icon={<User />}  value="4" />
          </TabList>
        </Box>
        <TabPanel id="tabPanel1" className={classes.activitiessTabPanel} value="1">
          
        </TabPanel>
        <TabPanel id="tabPanel2" className={classes.activitiessTabPanel} value="2">
          
        </TabPanel>
        <TabPanel id="tabPanel3" className={classes.activitiessTabPanel} value="3">
          
        </TabPanel>
        <TabPanel id="tabPanel4" className={classes.activitiessTabPanel} value="4">
          
        </TabPanel>
      </TabContext>

      {handleTimerGraph(valueBarGraph, totalCounts)}

    </div>
  );
};

export default ActivitiesPage;
